module.exports = __webpack_public_path__ + "img/lock-inactive.17eae411.svg";